import { render } from "./PopupFeedback.vue?vue&type=template&id=52805461"
import script from "./PopupFeedback.vue?vue&type=script&lang=js"
export * from "./PopupFeedback.vue?vue&type=script&lang=js"

import "./PopupFeedback.vue?vue&type=style&index=0&id=52805461&lang=css"

import exportComponent from "/home/nimens/projects/cafe-portos/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__